import Users from '../components/Users/Users';
import Company from '../components/Company/Company';
import Market from '../components/Market/Market';
import CompanyMarket from '../components/CompanyMarket/CompanyMarket';
import Stores from '../components/Stores/Stores';
import Apk from '../components/Application/Application';
import CompanyClient from '../components/CompanyClient/CompanyClient';
import CompanyStat from '../components/Statistics/CompanyStat/CompanyStat';
import StoreStat from '../components/Statistics/StoreStat/StoreStat';
import AppsStat from '../components/Statistics/AppsStat/AppsStat.js';
import Alerts from '../components/Alerts/Alerts';
import SummaryStat from '../components/Statistics/SummaryStat/SummaryStat';
import Calls from "../components/Promo/Calls/Calls";
import PromoterCategory from "../components/Promoter/PromoterCategory/PromoterCategory";
import PromoterSection from "../components/Promoter/PromoterSection/PromoterSection";
import PromoterVideo from "../components/Promoter/PromoterVideo/PromoterVideo";
import PromoterSalesPointActiveDevices
	from "../components/Promoter/PromoterSalesPointActiveDevices/PromoterSalesPointActiveDevices";
import PromoterVideoStats from "../components/Promoter/PromoterVideoStats/PromoterVideoStats";
import PromoterSalesPointStats from "../components/Promoter/PromoterSalesPointStats/PromoterSalesPointStats";
import PromoterSettings from "../components/Promoter/PromoterSettings/PromoterSettings";
import LoanOrders from "../components/Loan/Order/LoanOrders";
import LoanOrderInfo from "../components/Loan/Order/LoanOrderInfo";
import LoanOrderCreation from "../components/Loan/Order/LoanOrderCreation";
import LoanAvailableProps from "../components/Loan/Property/Available/LoanAvailableProps";
import LoanSummaryProps from "../components/Loan/Property/Summary/LoanSummaryProps";
import PlayerFolder from "../components/Player/PlayerFolder/PlayerFolder";
import PlayerMedia from "../components/Player/PlayerMedia/PlayerMedia";
import PlayerActiveSalesPoints from "../components/Player/PlayerActiveSalesPoints/PlayerActiveSalesPoints";
import PlayerMediaStats from "../components/Player/PlayerMediaStats/PlayerMediaStats";
import PlayerSalesPointStats from "../components/Player/PlayerSalesPointStats/PlayerSalesPointStats";
import promoterLogo from "../assets/images/promoter-logo.svg";
import GeoActivity from "../components/Statistics/GeoActivity/GeoActivity";

const companyAdminRoutes = [
	{
		collapse: false,
		path: "/",
		name: {
			"ru": "Главная",
			"en": "Main",
			"sk": "Hlavná"
		},
		state: "home",
		icon: "mdi mdi-home",
	},
	{
		navlabel: true,
		companyTitle: true,
		name: {
			"ru": "Администрирование",
			"en": "Administration",
			"sk": "Podávanie"
		},
		icon: "mdi mdi-dots-horizontal",
	},
	{
		collapse: false,
		path: "/dashboard/users",
		name: {
			"ru": "Пользователи",
			"en": "Users",
			"sk": "Užívatelia"
		},
		state: "users",
		icon: "mdi mdi-account-circle",
		component: Users
	},
	{
		collapse: false,
		path: "/dashboard/stores",
		name: {
			"ru": "Торговые точки",
			"en": "Trader points",
			"sk": "Body obchodníka"
		},
		state: "stores",
		icon: "mdi mdi-cart",
		component: Stores,
		paFeature: true,
	},
	{
		collapse: false,
		path: "/dashboard/retail",
		name: {
			"ru": "Маркет предприятия",
			"en": "Company market",
			"sk": "Podnikový trh"
		},
		state: "retail",
		icon: "mdi mdi-apps",
		component: CompanyMarket,
		paFeature: true,
	},
	{
		collapse: true,
		path: "/dashboard/statistics",
		name: {
			"ru": "Статистика",
			"en": "Statistics",
			"sk": "Štatistika"
		},
		state: "statistics",
		icon: "mdi mdi-information",
		paFeature: true,
		child: [
			{
				path: "/dashboard/statistics/stores",
				name: {
					"ru": "По компании",
					"en": "By company",
					"sk": "Podľa spoločnosti"
				},
				mini: "B",
				icon: "mdi mdi-houzz-box",
				component: CompanyStat
			},
            {
                path: "/dashboard/statistics/general",
                name: {
                    "ru": "Общий отчет",
                    "en": "General report",
					"sk": "Všeobecná správa"
                },
                mini: "B",
                icon: "mdi mdi-houzz-box",
                component: SummaryStat
            },
			{
				path: "/dashboard/statistics/apps",
				name: {
            		"ru": "По приложениям",
            		"en": "By apps",
                    "sk": "Podľa aplikácií"
            	},
				mini: "B",
				icon: "mdi mdi-animation",
				component: AppsStat
			},
			{
				path: "/dashboard/statistics/geoActivity",
				name: {
					"ru": "Geo активность",
					"en": "Geo activity",
					"sk": "Geo activity"
				},
				mini: "B",
				icon: "mdi mdi-map-marker-radius",
				component: GeoActivity,
				companyAttribute: "AllowGeoActivity",
			},
			/*{
				collapse: false,
				path: "/dashboard/statistics/callstat",
				state: "callstat",
				name: {
					"ru":"Продвижение",
					"en": "Promotion",
					"sk": "Povýšenie"
				},
				mini: "B",
				icon: "mdi mdi-apps",
				component: CallStatPage,
			},*/
		]
	},
	{
		collapse: false,
		path: "/dashboard/alerts",
		name: {
			"ru": "Уведомления",
			"en": "Alerts",
			"sk": "Výstrahy"
		},
		state: "alerts",
		icon: "mdi  mdi-message-text-outline",
		component: Alerts,
		paFeature: true,
	},
	// {
	// 	collapse: true,
	// 	path: "/dashboard/alerts",
	// 	name: {
	// 		"ru": "Уведомления",
	// 		"en": "Alerts"
	// 	},
	// 	state: "alerts",
	// 	icon: "mdi  mdi-message-text-outline",
	// 	child: [
	// 		{
	// 			path: "/dashboard/alerts/messages",
	// 			name: {
	// 				"ru":"История",
	// 				"en": "History"
	// 			},
	// 			mini: "B",
	// 			icon: "mdi mdi-clipboard-text",
	// 			component: Alerts,
	// 		},
	// 		{
	// 			path: "/dashboard/alerts/notifications",
	// 			name: {
	// 				"ru":"Действия",
	// 				"en": "Actions"
	// 			},
	// 			mini: "B",
	// 			icon: "mdi mdi-alert",
	// 			component: AlertNotifications
	// 		}
	// 	]
	// },
	{
		collapse: true,
		path: "/dashboard/company",
		name: {
			"ru": "Настройки",
			"en": "Settings",
			"sk": "Nastavenie"
		},
		state: "companies",
		icon: "mdi mdi-settings",
		child: [
			{
				path: "/dashboard/company",
				name: {
					"ru":"Компания",
					"en": "Company",
					"sk": "Firma"
				},
				mini: "B",
				icon: "mdi mdi-city",
				component: Company
			},
			{
				path: "/dashboard/client",
				name: {
					"ru": "Клиент",
					"en": "Client",
					"sk": "Klient"
				},
				mini: "B",
				icon: "mdi mdi-library-plus",
				component: CompanyClient,
				paFeature: true,
			},
		]
	},
	{
		collapse: false,
		path: "/dashboard/calls",
		name: {
			"ru": "Офферы",
			"en": "Offers",
			"sk": "Ponuky"
		},
		state: "calls",
		icon: "mdi  mdi-fire",
		component: Calls,
		paFeature: true,
	},
	{
		collapse: true,
		path: "/dashboard/player",
		name: {
			"ru": "Плеер",
			"en": "Player",
			"sk": "Player"
		},
		state: "player",
		icon: "mdi mdi-play-circle-outline",
		paFeature: true,
		child: [
			{
				path: "/dashboard/player/folders",
				name: {
					"ru": "Папки",
					"en": "Folders",
				},
				mini: "B",
				icon: "mdi mdi-folder-multiple",
				component: PlayerFolder
			},
			{
				path: "/dashboard/player/media",
				name: {
					"ru": "Медиа",
					"en": "Media",
				},
				mini: "B",
				icon: "mdi mdi-file-multiple",
				component: PlayerMedia
			},
			{
				path: "/dashboard/player/stats/activeSalesPoints",
				name: {
					"ru": "Активные торговые точки",
					"en": "Active sales points",
				},
				mini: "B",
				icon: "mdi mdi-store",
				component: PlayerActiveSalesPoints
			},
			{
				path: "/dashboard/player/stats/media",
				name: {
					"ru": "Воспроизведений медиа",
					"en": "Media playback amount",
				},
				mini: "B",
				icon: "mdi mdi-format-list-bulleted",
				component: PlayerMediaStats
			},
			{
				path: "/dashboard/player/stats/store",
				name: {
					"ru": "Воспроизведений по тт",
					"en": "Playback amount by stores",
				},
				mini: "B",
				icon: "mdi mdi-format-list-bulleted",
				component: PlayerSalesPointStats
			},
		]
	},
    {
        collapse: true,
        path: "/dashboard/promoter",
        name: {
            "ru": "Promoter",
            "en": "Promoter",
            "sk": "Promoter"
        },
        state: "promoter",
		svgIcon: promoterLogo,
        child: [
            {
                path: "/dashboard/promoter/videos",
                name: {
                    "ru": "Библиотека медиа",
                    "en": "Media library",
                },
                mini: "B",
                icon: "mdi mdi-file-video",
                component: PromoterVideo
            },
            {
                collapse: true,
                name: {
                    "ru": "Статистика",
                    "en": "Statistics",
                },
                state: "promoterStatistics",
                icon: "mdi mdi-settings-box",
                subchild: [
                    {
                        path: "/dashboard/promoter/stats/video",
                        name: {
                            "ru": "Отчет о воспроизведении",
                            "en": "Playback report",
                        },
                        mini: "B",
                        icon: "mdi mdi-format-list-bulleted",
                        component: PromoterVideoStats
                    },
                    {
                        path: "/dashboard/promoter/stats/store",
                        name: {
                            "ru": "Отчет по магазинам",
                            "en": "Store playback report",
                        },
                        mini: "B",
                        icon: "mdi mdi-format-list-bulleted",
                        component: PromoterSalesPointStats
                    },
					{
						path: "/dashboard/promoter/stats/activeDevices",
						name: {
							"ru": "Активные устройства",
							"en": "Active devices",
						},
						mini: "B",
						icon: "mdi mdi-cellphone-andrAdminid",
						component: PromoterSalesPointActiveDevices
					},
                ]
            },
            {
                collapse: true,
                name: {
                    "ru": "Настройки",
                    "en": "Settings",
                    "sk": "Nastavenie"
                },
                state: "promoterSettings",
                icon: "mdi mdi-settings-box",
                subchild: [
                    {
                        path: "/dashboard/promoter/settings",
                        name: {
                            "ru": "Основные",
                            "en": "Main",
                        },
                        mini: "B",
                        icon: "mdi mdi-settings",
                        component: PromoterSettings
                    },
                    {
                        path: "/dashboard/promoter/categories",
                        name: {
                            "ru": "Категории",
                            "en": "Categories",
                        },
                        mini: "B",
                        icon: "mdi mdi-folder-multiple",
                        component: PromoterCategory
                    },
                    {
                        path: "/dashboard/promoter/sections",
                        name: {
                            "ru": "Разделы",
                            "en": "Sections",
                        },
                        mini: "B",
                        icon: "mdi mdi-folder-multiple-outline",
                        component: PromoterSection
                    },]
            },
        ]
    },
	{
		collapse: true,
		path: "/dashboard/loan",
		name: {
			"ru": "Кредиты",
			"en": "Loans",
			"sk": "Úver"
		},
		state: "loan-orders",
		icon: "mdi mdi-credit-card",
		paFeature: true,
		child: [
			{
				path: "/dashboard/loan/orders",
				name: {
					"ru": "Заявки",
					"en": "Orders",
				},
				mini: "B",
				icon: "mdi mdi-format-list-bulleted",
				component: LoanOrders
			},
			{
				path: "/dashboard/loan/settings",
				name: {
					"ru": "Налаштування",
					"en": "Settings",
				},
				mini: "B",
				icon: "mdi mdi-settings",
				component: LoanSummaryProps
			}
		]
	},
	{
        collapse: false,
		path: "/chat",
		isLink: true,
        name: {
            "ru": "Поддержка",
            "en": "Support",
            "sk": "Podpora"
        },
        state: "chat",
        icon: "mdi mdi-comment-multiple-outline",
		paFeature: true,
    },
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/market/:appid",
		state: "app",
		component: Apk,
	},
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/market",
		//name: "Маркет",
		state: "market",
		//icon: "mdi mdi-apps",
		component: Market,

	},
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/statistics/companies/:companyid",
		state: "company-statistics",
		component: CompanyStat,
	},
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/statistics/stores/:storeid",
		state: "point-statistics",
		component: StoreStat,
	},
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/statistics/apps/:appid",
		state: "point-statistics",
		component: AppsStat,
	},
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/statistics/general/:apkid",
		state: "general-statistics",
		component: SummaryStat,
	},
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/loan/order/info/:orderId",
		state: "loan-order",
		component: LoanOrderInfo,
	},
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/loan/order/create",
		state: "loan-order-creation",
		component: LoanOrderCreation,
	},
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/loan/settings/:bankIntegration",
		state: "loan-order-creation",
		component: LoanAvailableProps,
	},
];

export default companyAdminRoutes;



// WEBPACK FOOTER //
// ./src/routes/companyAdminRoutes.js